import { type CustomerMessage, type Order } from "@repo/api";
import { ListView, ListViewItem } from "@repo/skapa";
import { t } from "@repo/translation";
import { hasItems } from "@repo/utils";

const getMessageTitle = (type?: CustomerMessage["messageType"]) => {
  switch (type) {
    case "INTERNAL":
      return t("label.internal_message");
    case "TSP_CUST":
      return t("label.external_message");
  }
};

export const CustomMessagesList = ({ order }: { order: Order | undefined }) => {
  if (!order || !hasItems(order.customMessages)) {
    return null;
  }

  return (
    <ListView id="customer-messages">
      {order.customMessages.map((message) => (
        <ListViewItem
          key={message.messageType}
          title={getMessageTitle(message.messageType)}
          description={message.messageText}
        />
      ))}
    </ListView>
  );
};
